<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12" v-if="!cadastroCategoria">
        <v-data-table
          :headers="headersCat"
          :items="categorias"
          class="elevation-1"
          style="border-radius: 10px;"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">Categorias</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn text @click="cadastroCategoria=true" tile color="#00253E" >
                <v-icon left dark>add_circle</v-icon> Adicionar Categoria
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-2" @click="editItemCat(item)">edit</v-icon>
            <v-icon small @click="deleteItemCat(item)">delete</v-icon>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-icon :color="item.status ? 'green' : 'red'">mdi-circle</v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="#94AAB4" @click="carregaDados">Recarregar</v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col ls="12" sm="12" md="12" lg="12" v-else>
        <!-- CARD INSERE Categorias -->
        <v-card style="border-radius: 10px;">
          <v-card-title>
            <span class="textoUser">{{ formTitleCat }}</span>
            <v-spacer></v-spacer>
            <p style="font-size:15px; color:#94AAB4"> *O preenchimento de todos os campos é obrigatório</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field v-model="categoria.ordem" outlined label="Ordem" color="#94AAB4"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="categoria.descricao" outlined label="Descrição" color="#94AAB4"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-switch v-model="categoria.status" inset label="Ativo" hide-details style="margin-top: 10px"></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="5">
                  <v-card outlined>
                    <v-img v-if="categoria.urlImagem" height="250" :src="categoria.urlImagem"></v-img>
                    <v-sheet v-else height="250" outlined width="100%">
                      <v-alert class="text-center" dark dense outlined :value="true" color="#00253E" type="info">Nenhuma imagem anexada</v-alert>
                    </v-sheet>
                    <v-card-title>Imagem</v-card-title>
                    <v-card-actions>
                      <v-btn v-if="!categoria.urlImagem" color="#00253E" text @click="uploadPhoto = true">Selecionar</v-btn>
                      <v-btn v-else color="#00253E" text @click="uploadPhoto = true">Alterar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#00253E" class="cssBotao" dark large @click="saveCategoria">Salvar</v-btn>
            <v-btn color="#94AAB4" max-width="" class="cssBotao" large dark @click="closeCategoria">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
     <Snackbar ref=chamaSnackbar />
     <v-dialog v-model="uploadPhoto" max-width="550px" max-height="300px" persistent>
       <v-toolbar color="#00695C" dark dense>
         <v-spacer></v-spacer>
         <v-btn icon dark @click="uploadPhoto = false">
           <v-icon>close</v-icon>
         </v-btn>
       </v-toolbar>
       <v-card>
         <v-container grid-list-md>
           <v-layout row wrap justify-center>
             <v-container fill-height fluid pa-1 justify-center>
               <vue-anka-cropper
                 :options="{
                   aspectRatio: 16/9,
                   closeOnSave: true,
                   cropArea: 'box',
                   croppedHeight: 500,
                   croppedWidth: 1000,
                   cropperHeight: false,
                   dropareaMessage: 'Arraste uma imagem aqui ou use o botão abaixo',
                   frameLineDash: [0,0],
                   frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                   handleFillColor: 'rgba(255, 255, 255, 0.2)',
                   handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                   handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                   handleSize: 10,
                   handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                   layoutBreakpoint: 500,
                   maxCropperHeight: 768,
                   maxFileSize: 8000000,
                   overlayFill: 'rgba(0, 0, 0, 0.5)',
                   previewOnDrag: false,
                   previewQuality: 0.65,
                   resultQuality: 0.8,
                   resultMimeType: 'image/jpeg',
                   selectButtonLabel: 'Escolher imagem',
                   showPreview: false,
                   skin: 'light',
                   uploadData: {},
                   uploadTo: false
                 }"
                 @cropper-error="erroCorte($event)"
                 @cropper-saved="salvarCorte($event)"
                 @cropper-cancelled="cancelaCorte()"
               ></vue-anka-cropper>
             </v-container>
           </v-layout>
         </v-container>
       </v-card>
     </v-dialog>
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import vueAnkaCropper from 'vue-anka-cropper'
  export default {
    components: {Snackbar, vueAnkaCropper},
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      addUser: false,
      dialog: false,
      cadastroCategoria: false,
      cadastroProduto: false,
      configAccess: false,
      headersProd: [
        { text: 'Código', value: 'codigo', align: 'start' },
        { text: 'Categoria', value: 'categoria.descricao' },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Detalhes', value: 'detalhes' },
        { text: 'Preço', value: 'preco' },
        { text: 'Status', value: 'status' },
        { text: 'Imagem', value: 'urlImagem' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      headersCat: [
        { text: 'Descrição', value: 'descricao' },
        { text: 'Ativo', value: 'status' },
        { text: 'Ações', value: 'action', sortable: false, align: "right" },
      ],
      perfis: [],
      editedIndexCat: -1,
      editedIndexProd: -1,
      categoriaDefault: {
        descricao: '',
        ordem: '',
        empresaId: '',
        status: true,
        urlImagem: ''
      },
      categoria: {
        descricao: '',
        ordem: '',
        empresaId: '',
        status: true,
        urlImagem: ''
      },
      categorias: [],
      uploadPhoto: false,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleCat () {
        return this.editedIndexCat === -1 ? 'ADICIONAR NOVA CATEGORIA' : 'EDITAR CATEGORIA'
      }    
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
    },

    created () {
      this.carregaDados()
    },

    methods: {
      async carregaDados () {
        //console.log(this.companyobj)
          await axios.get(`${baseApiUrl}Categorias?filter={"where":{"empresaId":"${this.companyobj.id}"}}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(res => {
            this.categorias = res.data
          })        
      },

      openDialog() {
        this.dialog = true
      },

      editItemCat(item) {
        this.editedIndexCat = this.perfis.indexOf(item)
        this.categoria = Object.assign({}, item)
        this.cadastroCategoria = true
      },

      async deleteItemCat (item) {
        var r = confirm('Deseja realmente excluir a categoria: ' + item.descricao + '?')
        if (r == true) {
          try {
            await axios.delete(`${baseApiUrl}Categorias/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
            this.carregaDados()
          } catch (error) {
            var vm;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }
      },

      closeCategoria () {
        this.cadastroCategoria = false
        setTimeout(() => {
          this.categoria = Object.assign({}, this.categoriaDefault)
          this.editedIndexCat = -1
        }, 300)
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async saveCategoria() {
        if (this.categoria.descricao != '') {
          try {
            this.categoria.empresaId = this.companyobj.id
            let res = await axios.post(`${baseApiUrl}Categorias/replaceOrCreate/?access_token=${sessionStorage.getItem('accToken')}`, this.categoria)  
            if (res.data != null) {
              var vm = this;
              this.closeCategoria()
              this.carregaDados()
            }
          } catch (error) {
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }
      },

      erroCorte (event) {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350","Ocorreu um erro durante a edição da imagem","DESCULPE");
      },

      salvarCorte(event) {
        this.categoria.urlImagem = event.croppedImageURI
        this.uploadPhoto = false
      },
      cancelaCorte(){
        this.uploadPhoto = false
      }
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
